define(["./nodeCommandsModule"], function (nodeCommandsModule) {
    "use strict";

    return nodeCommandsModule.service("nodeCommandViewTripOperationHistory", [
        "tripOperationHistoryModal",
        function (tripOperationHistoryModal) {
            return function (selection) {
                if (selection) {
                    tripOperationHistoryModal.openModal(selection);
                }
            };
        }
    ]);
});